<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import { useSiteStore } from '~/stores/site.store';

const site = useSiteStore();
</script>
<template>
  <p class="p-4 text-base-priority m-0 text-base">
    {{ $t('jpc-limits-info') }}
  </p>
  <div class="flex p-4 bg-base w-full">
    <Button
      type="primary"
      class="w-full justify-center"
      @click="site.deactivateModal()"
    >
      {{ $t('confirm') }}
    </Button>
  </div>
</template>
